module.exports = __webpack_public_path__ + "static/media/bowling-ball.cf51ba58.svg";